module.exports = __webpack_public_path__ + "img/selected4-min.44b8738b.png";